import { stirCommonIconsIds } from 'stirista-gui-kit';
export const loading_toaster_default_strings = {
  iconType: stirCommonIconsIds.error,
} as const;
